export default function HTMLVEditSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - HTML Viewer &amp; Editor
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            We&apos;re here to help you get the most out of the app.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I open an HTML file?
              </h3>
              <p className="mt-1">
                On the home screen, tap &quot;Open File&quot; to browse and
                select an HTML file from your device storage. You can also paste
                HTML code directly or load it from a URL.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I preview my HTML?
              </h3>
              <p className="mt-1">
                Tap the &quot;Run&quot; button in the editor to see a full-screen
                preview of your HTML output. You can also enable live preview or
                split-view mode for real-time feedback as you type.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I save my work?
              </h3>
              <p className="mt-1">
                Use the save option in the editor menu to save your HTML file to
                your device. You can also share your code directly from the app.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why does the app show a warning about large files?
              </h3>
              <p className="mt-1">
                For performance and stability, files larger than 450,000
                characters are truncated. This ensures the editor remains fast
                and responsive on all devices.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does the app require an internet connection?
              </h3>
              <p className="mt-1">
                No. You can write, edit, and preview HTML completely offline. An
                internet connection is only needed to load HTML from a URL or to
                display ads.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I insert images into my HTML?
              </h3>
              <p className="mt-1">
                Use the IMG shortcut in the quick insert toolbar. You can
                reference an image by URL or pick a local file from your device.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you have questions, feedback, or need help with the app, please
            reach out to us at{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We typically respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            Found something not working as expected? Please email us with the
            following details so we can help quickly:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your device model and OS version</li>
            <li>App version (found in Settings)</li>
            <li>A brief description of the issue</li>
            <li>Steps to reproduce the problem, if possible</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> HTML Viewer &amp; Editor
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
